"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var ProjectFiltersDialogComponent = /** @class */ (function () {
    function ProjectFiltersDialogComponent(dialogRef) {
        this.dialogRef = dialogRef;
        this.loading = false;
        this.errors = [];
        this.locations = [];
        this.locationsConfig = {
            nameProperty: 'name',
            searchable: true,
            loadingOptions: false
        };
        this.projects = [];
        this.projectsConfig = {
            nameProperty: 'name',
            searchable: true,
            loadingOptions: false
        };
        this.customers = [];
        this.customersConfig = {
            nameProperty: 'name',
            searchable: true,
            loadingOptions: false
        };
        this.model = {};
    }
    ProjectFiltersDialogComponent.prototype.ngOnInit = function () {
    };
    ProjectFiltersDialogComponent.prototype.onSelect = function (filterType, e) {
        this.model[filterType] = e;
    };
    ProjectFiltersDialogComponent.prototype.submit = function () {
        this.callback(this.model);
        this.dialogRef.close();
    };
    return ProjectFiltersDialogComponent;
}());
exports.ProjectFiltersDialogComponent = ProjectFiltersDialogComponent;
